import {
  Book,
  Calendar,
  CheckCheck,
  Clock,
  Edit3,
  Euro,
  Import,
  LayoutList,
  LucideIcon,
  Send,
  UserPlus,
  Users,
} from "lucide-react";

import { ActionKey } from "@/types";

type getActionDataArgs = {
  actionId: ActionKey;
  trackingCampaignId: number | null;
  scoreId: number | null;
  reviewId: number | null;
};

type ActionData = {
  icon: LucideIcon;
  url: string;
  isExternal?: boolean;
};

const getActionData = ({
  actionId,
  trackingCampaignId,
  scoreId,
  reviewId,
}: getActionDataArgs): ActionData => {
  switch (actionId) {
    case "verify_campaign_period":
      return {
        icon: Calendar,
        url: `/tracking/campaigns/${trackingCampaignId}/edit`,
      };
    case "verify_turnover_employees":
      return {
        icon: Euro,
        url: `/tracking/campaigns/${trackingCampaignId}/edit`,
      };
    case "activate_employee_survey":
      return {
        icon: Users,
        url: `/scores/${scoreId}/team_mode`,
      };
    case "invite_contributors":
      return {
        icon: UserPlus,
        url: `/users`,
      };
    case "complete_campaign":
      return {
        icon: Edit3,
        url: `/categories`,
      };
    case "import_data":
      return {
        icon: Import,
        url: `/scores/${scoreId}/import_deposits`,
      };
    case "validate_campaign":
      return {
        icon: CheckCheck,
        url: `/finished`,
      };
    case "view_analysis":
      return {
        icon: Book,
        url: `/reviews/${reviewId}`,
      };
    case "share_campaign":
      return {
        icon: Send,
        url: `/reviews/communicate/${reviewId}`,
      };
    case "referral_program":
      return {
        icon: Send,
        url: `https://try.hellocarbo.com/programme-parrainage-carbo`,
        isExternal: true,
      };
    case "consult_trajectory_actions":
      return {
        icon: LayoutList,
        url: `/trajectory/creation/introduction`,
      };
    case "launch_next_campaign":
      return {
        icon: Clock,
        url: `/tracking/campaigns/new`,
      };
    default:
      throw new Error(`Action ${actionId} not found`);
  }
};

export { getActionData };
